const ITEMS = [
  "Gratis gjeldsrådgivning i din kommune",
  "Du har rett til livsopphold",
  "NAV har plikt til å hjelpe deg",
  "Inkasso følger strenge regler",
  "Du er ikke alene",
];

export default function Marquee() {
  const doubled = [...ITEMS, ...ITEMS];
  return (
    <div data-testid="editorial-marquee" className="border-y border-border bg-accent/50 overflow-hidden py-5">
      <div className="animate-marquee flex w-max whitespace-nowrap">
        {doubled.map((text, i) => (
          <span key={i} data-testid="marquee-item" className="font-serif italic text-lg sm:text-xl text-primary/80 px-6 flex items-center gap-12">
            {text}
            <span className="text-terracotta not-italic text-sm">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
}
